import React from "react";
import EntryColor from "../container/EntryColor";

const Pool = ({ entries }) => {
  var tableContent = [];
  let classDel = "";

  let maxWinTotal = 0;
  let entryIdMaxWinTotal = null;

  if (entries) {
    entries.forEach((entry) => {
      const winTotal = entry.Odds.WinTotal;

      if (winTotal > maxWinTotal) {
        maxWinTotal = winTotal;
        entryIdMaxWinTotal = entry.EntryID;
      }
    });
  }
  entries &&
    entries.forEach((item, i) => {
      if (item.FinishPos === -1) {
        classDel = "scratchPool";
      } else {
        classDel = "";
      }

      tableContent.push(
        <tr
          key={i}
          className={entryIdMaxWinTotal === item.EntryID ? "maxWinPool" : ""}
        >
          <td
            style={{
              verticalAlign: "middle",
            }}
          >
            <EntryColor
              entryNum={item.EntryNum}
              saddleNum={item.SaddleNum}
              finishPos={item.FinishPos}
            />
          </td>
          <td
            style={{
              verticalAlign: "middle",
            }}
          >
            <span className={classDel}>{item.EntryName}</span>
          </td>
          <td
            style={{
              verticalAlign: "middle",
            }}
          >
            {item.FinishPos !== -1 ? (
              <span className={classDel}>{item.ML}</span>
            ) : (
              <span>-</span>
            )}
          </td>
          <td
            style={{
              verticalAlign: "middle",
            }}
          >
            {item.Odds.WinOdds !== "" ? (
              <span className={classDel}>{item.Odds.WinOdds}</span>
            ) : item.Odds.WinOdds === "" && item.FinishPos === -1 ? (
              <span>-</span>
            ) : (
              <span></span>
            )}
          </td>
          <td
            style={{
              verticalAlign: "middle",
            }}
          >
            {item.Odds.WinTotal !== 0 ? (
              <span className={classDel}>${item.Odds.WinTotal}</span>
            ) : item.Odds.WinTotal === 0 && item.FinishPos === -1 ? (
              <span>-</span>
            ) : (
              <span></span>
            )}
          </td>
          <td
            style={{
              verticalAlign: "middle",
            }}
          >
            {item.Odds.PlaceTotal !== 0 ? (
              <span className={classDel}>${item.Odds.PlaceTotal}</span>
            ) : item.Odds.PlaceTotal === 0 && item.FinishPos === -1 ? (
              <span>-</span>
            ) : (
              <span></span>
            )}
          </td>
          <td
            style={{
              verticalAlign: "middle",
            }}
          >
            {item.Odds.ShowTotal !== 0 ? (
              <span className={classDel}>${item.Odds.ShowTotal}</span>
            ) : item.Odds.ShowTotal === 0 && item.FinishPos === -1 ? (
              <span>-</span>
            ) : (
              <span></span>
            )}
          </td>
        </tr>
      );
    });

  return (
    <>
      <table className="table table-striped table-sm">
        <thead>
          <tr className="text-center">
            <th>#</th>
            <th>Horse</th>
            <th>ML</th>
            <th>Odds</th>
            <th>Win</th>
            <th>Place</th>
            <th>Show</th>
          </tr>
        </thead>
        <tbody className="table-sm text-center">{tableContent}</tbody>
      </table>
    </>
  );
};

export default Pool;
